import { createSlice } from '@reduxjs/toolkit';

import { PageLoaderState } from 'src/shared/models';

import { loadingPage } from './pageLoaderThunk';

const initialState: PageLoaderState = {
	isLoading: false
};

export const pageLoaderSlice = createSlice({
	name: 'pageLoader',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(loadingPage.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(loadingPage.fulfilled, (state) => {
				state.isLoading = false;
			})
			.addCase(loadingPage.rejected, (state) => {
				state.isLoading = false;
			});
	}
});

export default pageLoaderSlice.reducer;
